import React, { useState, useEffect } from 'react';
import CountdownTimer from './CountdownTimer';
import { toWIB } from '../../utils/dateUtils';

const CountdownSection = ({ eventData }) => {
  const [dominantColor, setDominantColor] = useState('#3b82f6');

  useEffect(() => {
    const getDominantColor = async () => {
      if (eventData?.imageUrl) {
        try {
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = eventData.imageUrl;
          
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
            let r = 0, g = 0, b = 0;
            
            for (let i = 0; i < imageData.length; i += 4) {
              r += imageData[i];
              g += imageData[i + 1];
              b += imageData[i + 2];
            }
            
            r = Math.floor(r / (imageData.length / 4));
            g = Math.floor(g / (imageData.length / 4));
            b = Math.floor(b / (imageData.length / 4));
            
            // Adjust colors for better contrast and readability
            r = Math.min(255, Math.max(50, r));
            g = Math.min(255, Math.max(50, g));
            b = Math.min(255, Math.max(50, b));
            
            setDominantColor(`rgb(${r}, ${g}, ${b})`);
          };
        } catch (error) {
          console.error('Error getting dominant color:', error);
        }
      }
    };

    getDominantColor();
  }, [eventData?.imageUrl]);

  return (
    <section className="bg-slate-50 text-gray-800 py-16 px-4 text-center relative">
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="bg-white rounded-lg p-8 shadow-xl border border-slate-200">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-pink-500 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-orange-600 via-pink-500 to-purple-600 bg-clip-text text-transparent">
            Event Countdown
          </h2>
          
          <p className="text-lg md:text-xl font-medium text-slate-700 mb-8 max-w-2xl mx-auto">
            Don't miss out on this exciting event. Mark your calendar and get ready for an unforgettable experience.
          </p>
          
          <CountdownTimer 
            targetDate={toWIB(eventData?.startAt).getTime()} 
            dominantColor={dominantColor}
          />
          
          <div className="mt-8 inline-flex items-center gap-2 text-base font-semibold text-slate-600 bg-slate-100 px-4 py-2 rounded-lg border border-slate-200">
            <svg className="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Event starts in your local timezone
          </div>
        </div>
      </div>
    </section>
  );
};

export default CountdownSection;